import * as React from "react";
import { makeIcon } from "./makeIcon";
const AddBox = props => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "16px", height: "16px", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" }),
    React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })));
export const AddBoxIcon = makeIcon("addBox")(AddBox);
//# sourceMappingURL=AddBox.js.map